import { Routes } from "@shuttlerock/router";
import { useTranslation } from "../../i18n";
import { ErrorPage } from "./ErrorPage";

export const NotFoundPage = () => {
  const { t } = useTranslation("errorPage");
  return (
    <ErrorPage
      title={t("notFound:title")}
      body={t("notFound:defaultMessage")}
      primaryButton={{
        text: t("notFound:button:primary"),
        route: Routes.External.ContactSupport,
      }}
      secondaryButton={{
        text: t("notFound:button:secondary"),
        route: Routes.Home,
      }}
    />
  );
};
